import { Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { BCPShop, BCPSquarePlus } from "../../../components/icons/bcp/BCPIcons";
import { isAppMode } from "../../../global/AppOverlay";
import OptionsMenu from "../../../components/layout/OptionsMenu";
import { updateFilters } from "../../../components/utilities/SortFilterFunctions";
import ListResponsive from "../../../components/other/ListResponsive";
import InfoContainer from "../../../components/layout/InfoContainer";
import OrganizationCardSmall from "../../../components/layout/OrganizationCardSmall";

export default function OrgDashOrganizations(props) {
  const { loading, organizations } = props;
  const appMode = isAppMode();

  const [filters, setFilters] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <Typography variant="h3" fontWeight="700">
          Managed Organizations
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Button
          variant="contained"
          href="/organize/game-stores"
          target={`${appMode ? "_blank" : "_self"}`}
          startIcon={<BCPShop />}
          fullWidth
        >
          View My Organizations
        </Button>
      </Grid>

      <Grid item xs={12}>
        {!loading && !organizations?.length ? (
          <InfoContainer
            title="No organizations found"
            body={
              "It looks like there's nothing here. Create or join an organization to get started!"
            }
            ActionButton={
              <Button
                variant="contained"
                href={"/organize/organization"}
                startIcon={<BCPSquarePlus />}
              >
                Create Organization
              </Button>
            }
            sx={{ mt: 1 }}
          />
        ) : (
          <ListResponsive
            name="Managed organizations"
            originalList={
              loading ? null : organizations?.length ? organizations : []
            }
            doPages
            initialRowsPerPage={9}
            itemsPerPage={[9]}
            centerNav
            buttonGroup={false}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid key={index} item xs={12} sm={6} md={4} sx={{ p: 1 }}>
                  <OrganizationCardSmall
                    organization={row}
                    key={row?.id || index}
                    organize
                  />
                </Grid>
              ),
            }}
          />
        )}
      </Grid>

      {/* Sorting */}
      <OptionsMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        items={[
          {
            name: "sort-date-asc",
            label: "Start Date Ascending",
            selected: filters.includes("sort-date-asc"),
            onClick: () =>
              updateFilters("sort-date-asc", false, filters, setFilters),
          },
          {
            name: "sort-date-desc",
            label: "Start Date Descending",
            selected: filters.includes("sort-date-desc"),
            onClick: () =>
              updateFilters("sort-date-desc", false, filters, setFilters),
          },
          {
            name: "sort-name-asc",
            label: "Name Ascending",
            selected: filters.includes("sort-name-asc"),
            onClick: () =>
              updateFilters("sort-name-asc", false, filters, setFilters),
          },
          {
            name: "sort-name-desc",
            label: "Name Descending",
            selected: filters.includes("sort-name-desc"),
            onClick: () =>
              updateFilters("sort-name-desc", false, filters, setFilters),
          },
          {
            name: "sort-rounds-asc",
            label: "Rounds Ascending",
            selected: filters.includes("sort-rounds-asc"),
            onClick: () =>
              updateFilters("sort-rounds-asc", false, filters, setFilters),
          },
          {
            name: "sort-rounds-desc",
            label: "Rounds Descending",
            selected: filters.includes("sort-rounds-desc"),
            onClick: () =>
              updateFilters("sort-rounds-desc", false, filters, setFilters),
          },
        ]}
        name="organizations-sort-menu"
      />

      {/* Filters */}
      <OptionsMenu
        anchorEl={anchorEl2}
        setAnchorEl={setAnchorEl2}
        items={[
          {
            name: "filter-online",
            label: "Online Event",
            selected: filters.includes("filter-online"),
            onClick: () =>
              updateFilters(
                "filter-online",
                "filter-exclude-online",
                filters,
                setFilters
              ),
          },
          {
            name: "filter-exclude-online",
            label: "Exclude Online",
            selected: filters.includes("filter-exclude-online"),
            onClick: () =>
              updateFilters(
                "filter-exclude-online",
                "filter-online",
                filters,
                setFilters
              ),
          },
          { divider: true },

          {
            name: "filter-singles",
            label: "Singles organizations",
            selected: filters.includes("filter-singles"),
            onClick: () =>
              updateFilters(
                "filter-singles",
                ["filter-doubles", "filter-teams", "filter-board"],
                filters,
                setFilters
              ),
          },
          {
            name: "filter-doubles",
            label: "Doubles organizations",
            selected: filters.includes("filter-doubles"),
            onClick: () =>
              updateFilters(
                "filter-doubles",
                ["filter-singles", "filter-teams", "filter-board"],
                filters,
                setFilters
              ),
          },
          {
            name: "filter-teams",
            label: "Teams organizations",
            selected: filters.includes("filter-teams"),
            onClick: () =>
              updateFilters(
                "filter-teams",
                ["filter-singles", "filter-doubles", "filter-board"],
                filters,
                setFilters
              ),
          },
        ]}
        name="organizations-filter-menu"
      />
    </Grid>
  );
}
